<div class="logo-spinner">
  <img src="/assets/img/logos/Original.svg" alt="Cykubed logo">
  <p *ngIf="label">{{ label}}</p>
  <fa-icon [icon]="icons.spinner" size="2x" [spin]="true"></fa-icon>
</div>

